import script from "./AddStore.vue?vue&type=script&setup=true&lang=js"
export * from "./AddStore.vue?vue&type=script&setup=true&lang=js"

import "./AddStore.vue?vue&type=style&index=0&id=a5d1c9b4&lang=css"

const __exports__ = script;

export default __exports__